const ID_HEADER = 'js-snippetsHeader'
export const CLASS_NAME_SCROLL_TRIGGER = 'js-scrollTrigger'

document.addEventListener('DOMContentLoaded', () => {
  const elementsScrollTrigger = document.getElementsByClassName(
    CLASS_NAME_SCROLL_TRIGGER
  )
  if (elementsScrollTrigger.length)
    Array.from(elementsScrollTrigger).forEach((element) => {
      setEventScroll(element)
    })
})

export const setEventScroll = (element) => {
  element.addEventListener('click', () => {
    const idScrollTarget = element.dataset.idScrollTarget
    scroll(idScrollTarget)
  })
}

export const scroll = (idScrollTarget) => {
  const elementTarget = document.getElementById(idScrollTarget)
  const elementHeader = document.getElementById(ID_HEADER)
  const headerHeight = elementHeader.dataset.height || 0
  const clientRect = elementTarget ? elementTarget.getBoundingClientRect() : 0
  const top = window.scrollY + clientRect.top - headerHeight
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}

export const scrollStickyHeader = (elementTarget) => {
  const elementHeader = document.getElementById(ID_HEADER)
  const headerHeight = elementHeader.dataset.height
  const top =
    window.scrollY + elementTarget.getBoundingClientRect().top - headerHeight
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}
